import { createFileRoute } from '@tanstack/react-router';

import { GuestResourceView } from '../features/guest/guest-resource-view';

/**
 * `/guest/$token` — 로그인 없는 게스트 읽기 (E14 §2, D52 · D56 · `#211`)
 *
 * 로그인·온보딩 게이트가 없다 — 게스트는 세션이 아예 없다. 전역 nav는 `__root.tsx`가
 * 이 경로에서 감춘다(S18 §4 "전역 탐색이나 Labs 화면을 노출하지 않는다").
 */
export const Route = createFileRoute('/guest/$token')({
  component: GuestRoute,
});

function GuestRoute() {
  const { token } = Route.useParams();
  return <GuestResourceView token={token} />;
}
